window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".custom-dropdown").forEach(select => {
    select.addEventListener("click", (e: MouseEvent) => {
      if (e.target !== select.querySelector(".filter")) {
        return;
      }

      select.classList.toggle("open");
    });

    document.addEventListener("click", (e: any) => {
      if (!select.contains(e.target)) {
        select.classList.remove("open");
      }
    });
  });

  document.querySelector(".mobile-controls")?.addEventListener("click", () => {
    document.querySelector("#jobSelect").classList.toggle("transform");
    if (document.body.style.overflow !== 'hidden') {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
      document.documentElement.style.overflow = 'visible';
    }
    document.querySelector(".arrow").classList.toggle("top");
  });
});

export function submitJobSelector() {
  (document.querySelector("#jobSelect") as HTMLFormElement).submit();
  document.querySelector("#jobSelect").classList.toggle("transform");
  document.querySelector(".arrow").classList.toggle("top");
  document.body.style.overflow = 'visible';
  document.documentElement.style.overflow = 'visible';
}
globalThis.submitJobSelector = submitJobSelector;
